import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import {IconButton, TextField} from '@mui/material';
import Iconify from "../Iconify";

// ----------------------------------------------------------------------

RHFSelectIcon.propTypes = {
    children: PropTypes.node,
    name: PropTypes.string,
    icon: PropTypes.string,
};

export default function RHFSelectIcon({ name, disabled, children, icon, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            // defaultValue="Jedan smer" // Set the default value to "Jedan smer"
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    disabled={disabled}
                    size="small"
                    {...field}
                    select
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <IconButton>
                                <Iconify icon={icon}/>
                            </IconButton>
                        ),
                    }}
                    error={!!error}
                    helperText={error?.message}
                    {...other}
                >
                    {children}
                </TextField>
            )}
        />
    );
}
